import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "flex flex-col min-h-screen bg-secondary-100"
}
const _hoisted_2 = { class: "flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNavbar = _resolveComponent("AppNavbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_CartDrawer = _resolveComponent("CartDrawer")!
  const _component_AppToast = _resolveComponent("AppToast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showNavbar)
      ? (_openBlock(), _createBlock(_component_AppNavbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.showNavbar)
      ? (_openBlock(), _createBlock(_component_AppFooter, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_CartDrawer),
    _createVNode(_component_AppToast)
  ]))
}